import * as types from "../../steppers/store/steppers.actionType";
import * as commonActionType from "@common/store/common/common.actionsType";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  activeStep: 0,
  steps: undefined,
  initialRender: true
});
export default function reduce(state = initialState, action = {}) {
  const { payload } = action;
  switch (action.type) {
    case types.SET_ACTIVE_STEP:
      return state.merge({ activeStep: payload });
    case types.SET_STEPS:
      return state.merge({ steps: payload });
    case types.SET_INITIAL_RENDER:
      return state.merge({ initialRender: payload });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
}
